import React, { useState } from "react";
import { useTranslation } from "lib/i18n";
import Seo from "components/Seo";

const Contact = () => {
  const { t, language } = useTranslation();
  const isFrench = language === "fr";
  const title = isFrench ? "Contacter Quivio | Conseil logiciel" : "Contact Quivio | Software Consulting";
  const description = isFrench
    ? "Parlez-nous de votre projet logiciel pour obtenir des prochaines étapes claires, budgets et échéanciers."
    : "Tell us about your software project. Get clear next steps, budgets, and timelines from the Quivio team.";
  const [formData, setFormData] = useState({
    name: "",
    subject: "",
    email: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  return (
    <>
      <Seo title={title} description={description} path="/contact" />
      <div className="contact section-title mt-5">
        <div className="container text-white">
          <div className="row align-items-center">
            <div className="col-md-7 mx-auto">
              <div className="contact-title mb-5 mt-5">
                <h1 className="title-font title-font-size">{t("contact.heading")}</h1>
                <p className="mt-4 mb-4 title-font-2">
                  {t("contact.intro")}
                </p>
              </div>
            </div>

            <div className="col-lg-8 mx-auto text-white">
              <div className="contact-form mb-5 mt-5">
                <form
                  action="https://public.herotofu.com/v1/4fa79bd0-a871-11ef-b84b-3558f10aabf2"
                  method="post"
                  acceptCharset="UTF-8"
                >
                  <div className="form-group">
                    <div className="col-12">
                      <label className="form-label" htmlFor="name">
                        {t("contact.nameLabel")}
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder={t("contact.namePlaceholder")}
                        name="name"
                        id="name"
                        value={formData.name}
                        onChange={handleChange}
                        autoComplete="name"
                      />
                    </div>
                  </div>
                  <div className="form-group">
                    <div className="col-12">
                      <label className="form-label" htmlFor="subject">
                        {t("contact.subjectLabel")}
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder={t("contact.subjectPlaceholder")}
                        name="subject"
                        id="subject"
                        value={formData.subject}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                  <div className="form-group">
                    <div className="col-12">
                      <label className="form-label" htmlFor="email">
                        {t("contact.emailLabel")}
                      </label>
                      <input
                        type="email"
                        className="form-control"
                        placeholder={t("contact.emailPlaceholder")}
                        name="email"
                        id="email"
                        value={formData.email}
                        onChange={handleChange}
                        autoComplete="email"
                        required
                      />
                    </div>
                  </div>
                  <div className="form-group">
                    <div className="col-12">
                      <label className="form-label" htmlFor="message">
                        {t("contact.messageLabel")}
                      </label>
                      <textarea
                        className="form-control"
                        placeholder={t("contact.messagePlaceholder")}
                        rows="4"
                        name="message"
                        id="message"
                        value={formData.message}
                        onChange={handleChange}
                        autoComplete="off"
                        required
                      />
                    </div>
                  </div>
                  <div
                    style={{
                      textIndent: "-99999px",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      position: "absolute",
                    }}
                    aria-hidden="true"
                  >
                    <input type="text" name="_gotcha" tabIndex="-1" autoComplete="off" />
                  </div>
                  <div className="col-12 text-center">
                    <button type="submit" className="btn mt-5 cta-accent">
                      {t("contact.submit")}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Contact;
